/** @jsx jsx */

import React, { Fragment as _, memo } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import { colors } from 'styles/variables';

import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import SVG from 'components/lib/SVG';
import ContinueBtn from 'components/lib/ContinueBtn/continueBtn_v2';
import Container from 'components/Layouts/ContainerLogical';
import { interactionContext } from './interactionContext';
import Media from 'components/lib/Media';
import { Block } from 'factories/block';
import getBlockById from 'services/apiHelpers/getBlockById';
import IELayout from 'components/Layouts/IELayout';
import Assessment from './Assessment';
import AssessmentIntroduction from './AssessmentIntroduction';
import AssessmentQuestion from './AssessmentQuestion';
import AssessmentResults from './AssessmentResults';

const Components = {
  Row,
  Column,
  Text: EditableText,

  Assessment,
  AssessmentIntroduction,
  AssessmentQuestions: ({ children, ...props }) => children,
  AssessmentQuestion,
  AssessmentResults,
  Image,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: ContinueBtn,
  Video,
  SVG,
  Media,
  ...IELayout(interactionContext),
};

const AssessmentDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);

  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null } as any}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
});
// shouldUpdate

export default AssessmentDisplay;
